import {Component} from '@angular/core'
import {Router} from '@angular/router'
import {AuthService} from '../auth.service'
import {I18nService} from '../../@core/translate/i18n.service'

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent  {
  errors: string[] = []
  user: {login: string, password: string} = {login: null, password: null}
  submitted: boolean = false

  constructor(
    private authService: AuthService,
    private i18n: I18nService,
    private router: Router
  ) {}

  async processLogin() {
    this.submitted = true
    try {
      await this.authService.login(this.user)
      this.submitted = false
      this.router.navigate(['/app'], {replaceUrl: true})
    } catch (e) {
      this.submitted = false
      this.errors = ['Cannot log in']
    }
  }
}
